import React from "react";

import { EmailConfirmationProps } from "@layout/modals/emailConfirmationModals/emailConfirmationModal/types";
import { setAuthParamToURL } from "@layout/modals/utils";
import { useLocation } from "@reach/router";

import { CircleIcon, CircleIconColorEnum } from "@/components/common/circleIcon";
import { Button, ButtonColorEnum } from "@components/common/button";
import { Icon, IconSizeEnum, IconTypeEnum } from "@components/common/icon";

const EmailConfirmationModal = ({ isSuccess = false }: EmailConfirmationProps) => {
  const location = useLocation();

  const closeHandler = () => {
    setAuthParamToURL(location, null);
  };

  return (
    <div className="auth__email-confirmation">
      {isSuccess
        && (
          <>
            <CircleIcon type={IconTypeEnum.Tick} color={CircleIconColorEnum.Green} />
            <div className="h2">Вы успешно подтвердили свой email и завершили регистрацию</div>
          </>
        )}
      {!isSuccess
        && (
          <>
            <CircleIcon type={IconTypeEnum.Exclamation} color={CircleIconColorEnum.Red} />
            <div className="h2">Не удалось подтвердить email</div>
            <p>Возможно, время действия ссылки истекло. Попробуйте запросить новое письмо с&nbsp;подтверждением</p>
          </>
        )}
      <Button
        onClick={closeHandler}
        text="Закрыть"
        color={ButtonColorEnum.Light}
      />
    </div>
  );
};

export default EmailConfirmationModal;
